import { useEffect, useState } from 'react';

import { useGetConfigByIdAsync } from './useMutation';

export const useFaceSyncLegacyFlag = () => {
  const [useLegacy, setUseLegacy] = useState(false);
  const { mutateAsync: getConfig } = useGetConfigByIdAsync();

  useEffect(() => {
    getConfig()
      .then((config) => setUseLegacy(config?.faceSync?.useLegacyFaceSyncFlow ?? false))
      .catch(() => setUseLegacy(false));
  }, []);

  return useLegacy;
};
